/**
 * PartnerFeeToHeadPage Component
 * 협력사 → 본사 수수료 관리 페이지
 *
 * 본사가 협력사에게 설정하는 수수료 (일정산/주정산 수수료)
 * 본사만 접근 가능
 */
import React from "react";
import FeeManagement from './FeeManagement';

const PartnerFeeToHeadPage: React.FC = () => {
    return (
        <div className="supplier-selection-page">
            {/* 페이지 제목 */}
            <div className="page-title-wrapper">
                <h1 className="page-title">협력사 → 본사 수수료</h1>
            </div>

            {/* 수수료 관리 컴포넌트 */}
            <FeeManagement />
        </div>
    );
};

export default PartnerFeeToHeadPage;
